import React from "react";

import Button from "@atoms/Button";

interface IProps {
  removeDisabled?: boolean;
  quantity: number;
  handleChange: (num: number) => void;
  quantityAvailable?: number;
  isGift?: boolean;
  handleRemove?: () => void;
}

export default function Stepper({
  removeDisabled,
  quantity,
  handleChange,
  quantityAvailable = 99,
  isGift = false,
  handleRemove,
}: IProps) {
  const handleQuantity = (type: "add" | "remove") => {
    if (type === "add") {
      if (quantityAvailable >= quantity) {
        handleChange(quantity + 1);
      }
    }

    if (type === "remove") {
      handleChange(quantity - 1);
    }
  };

  return (
    <div className="flex gap-2.5">
      <div className="flex w-fit gap-1 bg-neutral-100 text-black">
        <Button
          as="text"
          className="w-6 justify-center text-black!"
          disabled={removeDisabled}
          onClick={() => {
            handleQuantity("remove");
          }}
        >
          -
        </Button>
        <span className="w-6 text-center">{quantity}</span>
        <Button
          as="text"
          className="w-6 items-center justify-center text-black!"
          onClick={() => {
            handleQuantity("add");
          }}
        >
          +
        </Button>
      </div>
      {!isGift && handleRemove && (
        <Button as="text" className="font-normal" onClick={handleRemove} variant="secondary">
          Remove
        </Button>
      )}
    </div>
  );
}
